/**
 * Captastic — Clear cart (POST /cart/clear.js after confirm).
 * Event-delegated; safe if the script tag appears more than once.
 */
(function () {
  if (window.__captasticClearCartBound) return;
  window.__captasticClearCartBound = true;

  function cartRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    if (typeof window.routes === 'object' && window.routes.cart_url) {
      var u = window.routes.cart_url;
      return u.endsWith('/cart') ? u.slice(0, -4) || '/' : '/';
    }
    return '/';
  }

  function clearUrl() {
    var root = cartRoot();
    if (!root.endsWith('/')) root += '/';
    return root + 'cart/clear.js';
  }

  function cartPageUrl() {
    if (typeof window.routes === 'object' && window.routes.cart_url) {
      return window.routes.cart_url;
    }
    var root = cartRoot();
    if (!root.endsWith('/')) root += '/';
    return root + 'cart';
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-captastic-clear-cart]');
    if (!btn) return;

    event.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;

    var message =
      btn.getAttribute('data-confirm') ||
      'Remove all items from your cart?';
    if (!window.confirm(message)) return;

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    fetch(clearUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Clear cart failed');
        return response.json().catch(function () {
          return {};
        });
      })
      .then(function () {
        window.location.href = cartPageUrl();
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        window.alert('Could not clear the cart. Please try again.');
      });
  });
})();
